module.exports = __webpack_public_path__ + "img/背景1.2774f37c.jpg";